export default "__VITE_ASSET__BWC0qFVq__"